import { render } from "./firstinfoView.vue?vue&type=template&id=61755e08&scoped=true"
import script from "./firstinfoView.vue?vue&type=script&lang=js"
export * from "./firstinfoView.vue?vue&type=script&lang=js"

import "./firstinfoView.vue?vue&type=style&index=0&id=61755e08&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61755e08"]])

export default __exports__